export const grundstueckSearchModeName = 'searchMode';
export type GrundstueckSearchMode = 'searchStandard' | 'searchErweitert' | 'searchEgrid';
